import OnlyBattery from './OnlyBattery';
export default OnlyBattery;
